import React, { useRef, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import FormBuilder from './FormBuilder';
import FormHeader from './FormHeader';

const FormEdit = ({ form: initialForm, saveForm, saveText, options, builder, onChange }) => {
  const builderRef = useRef();
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    setForm(initialForm);
  }, [initialForm]);

  const handleDisplayChange = (displayValue) => {
    const updatedForm = {
      ...form,
      display: displayValue,
    };
    setForm(updatedForm);
    if (onChange && typeof onChange === "function") {
      onChange(updatedForm);
    }
  };

  const handleSaveForm = (updatedForm) => {
    setForm(updatedForm);
    if (saveForm && typeof saveForm === "function") {
      saveForm(updatedForm);
    }
  };

  const handleFormChange = (formData) => {
    const updatedForm = {
      ...form,
      ...formData,
    };
    setForm(updatedForm);
    if (onChange && typeof onChange === "function") {
      onChange(updatedForm);
    }
  };

  return (
    <div>
      <FormHeader
        initialForm={form}
        onSave={handleSaveForm}
        saveText={saveText}
        builderRef={builderRef}
        onDisplayChange={handleDisplayChange}
      />
      <FormBuilder
        key={form._id}
        form={form}
        options={options}
        builder={builder}
        builderRef={builderRef}
        onChange={handleFormChange}
      />
    </div>
  );
};

FormEdit.propTypes = {
  form: PropTypes.object.isRequired,
  options: PropTypes.object,
  builder: PropTypes.any,
  saveForm: PropTypes.func,
  saveText: PropTypes.string,
  onChange: PropTypes.func,
};

FormEdit.defaultProps = {
  form: {
    title: '',
    name: '',
    path: '',
    display: 'form',
    type: 'form',
    components: [],
  }
};

export default FormEdit;